module.exports = __webpack_public_path__ + "img/illu_wip_2.fcdabc16.png";